import { useRef } from 'react';

const DEFAULT_DEBOUNCE_MS = 1000;

export default function useNavigationDebounce(debounceMs = DEFAULT_DEBOUNCE_MS) {
    const lastNavigatedAtRef = useRef<number>(0);
    const lastUrlRef = useRef<string>('');

    return (url: string) => {
        const now = Date.now();
        if (url === lastUrlRef.current && now - lastNavigatedAtRef.current < debounceMs) {
            return false;
        }
        lastNavigatedAtRef.current = now;
        lastUrlRef.current = url;
        return true;
    };
}
